import { useCallback } from 'react';

import { ActionBar, BookIcon, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { visitActionBarTranslationKeys, visitTranslationKeys } from '../../translations';

import { VisitActionBarOrder } from './VisitActionBar';

type GoToEducationalMaterialsActionProps = {
   readonly visitId: number;
};

export const GoToEducationalMaterialsAction = (props: GoToEducationalMaterialsActionProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(false);
   const goToEducationalMaterials = useCallback(
      (): void =>
         push(visitPaths.getEducationalMaterialsPath({ params: { visitId: props.visitId } }), {
            label: visitTranslationKeys.goBackToVisit,
         }),
      [push, props.visitId]
   );

   return (
      <ActionBar.OptionalLink
         testId={'goToEducationalMaterials'}
         icon={<BookIcon />}
         label={visitActionBarTranslationKeys.educationalMaterialsForPatient}
         onClick={goToEducationalMaterials}
         order={VisitActionBarOrder.EducationalMaterials}
         nowrap
      />
   );
};
